<template>
  <div class="footer">
    <div class="logoFooter">
      <img src="../assets/icons/logo.svg" width="40%" />
      <p>
        © 2023-2026, Sensa — Проект, предназначенный<br />для комфортного поиска
        эскорт-специалистов<br />и моделей для досуга по всей России.
      </p>
      <button class="writeUs" @click="supportClick">
        <img src="../assets/icons/paperPlane.svg" />
        Написать нам
      </button>
      <p>Все права защищены.</p>
    </div>
    <div class="blockFooter">
      <p class="footerHeaderText">Информация</p>
      <a href="#"><p>Главная</p></a>
      <a href="/#aboutUs"><p>О проекте</p></a>
      <a @click="supportClick"><p>Поддержка</p></a>
    </div>
    <div class="blockFooter">
      <p class="footerHeaderText">Категории</p>
      <a href="/girls/1?premium=1"><p>Премиум</p></a>
      <a href="/girls/1?elite=1"><p>Элитные</p></a>
      <a href="/girls/1?individual=1"><p>Индивидуалки</p></a>
      <a href="/girls/1?slut=1"><p>Проститутки</p></a>
      <a href="/girls/1?massage=1"><p>Массажистки</p></a>
    </div>
    <div class="blockFooter">
      <p class="footerHeaderText">Дополнительно</p>
      <a
        href="https://telegra.ph/Polzovatelskoe-soglashenie-dlya-klientov-ehskort-agentstva-12-19-2"
        ><p>Политика<br />конфиденциальности и правила сервиса</p></a
      >
    </div>
  </div>
  <div class="mobileFooter">
    <div class="mobileLogoFooter">
      <img src="../assets/icons/logo.svg" width="40%" />
      <!-- <p>© 2023-2026, Sensa — Проект, предназначенный<br>для комфортного поиска эскорт-специалистов<br>и моделей для досуга по всей России.</p>
			<button class='writeUs' @click="supportClick">
				<img src='../assets/icons/paperPlane.svg'/>
				Написать нам
			</button> -->
      <p>Все права защищены.</p>
    </div>
    <p>
      © 2023-2026, Sensa<br />— Проект, предназначенный<br />для комфортного поиска<br />эскорт-специалистов<br />и
      моделей для досуга<br />по всей России.
    </p>
    <div class="mobileBlockFooter">
      <p class="mobileFooterHeaderText">Информация</p>
      <a href="#"><p>Главная</p></a>
      <a href="/#aboutUs"><p>О проекте</p></a>
      <a @click="supportClick">Поддержка</a>
      <p class="mobileFooterHeaderText">Дополнительно</p>
      <a
        href="https://telegra.ph/Polzovatelskoe-soglashenie-dlya-klientov-ehskort-agentstva-12-19-2"
        ><p>Политика<br />конфиденциальности и правила сервиса</p></a
      >
    </div>
    <div class="mobileBlockFooter">
      <p class="mobileFooterHeaderText">Категории</p>
      <a href="/girls/1?premium=1"><p>Премиум</p></a>
      <a href="/girls/1?elite=1"><p>Элитные</p></a>
      <a href="/girls/1?individual=1"><p>Индивидуалки</p></a>
      <a href="/girls/1?slut=1"><p>Проститутки</p></a>
      <a href="/girls/1?massage=1"><p>Массажистки</p></a>
    </div>
    <button class="writeUs" @click="supportClick">
      <img src="../assets/icons/paperPlane.svg" />
      Написать нам
    </button>
  </div>
</template>

<script>
import { openChatWidget } from "@/utils/chatWidget";

export default {
  name: "FooterComponent",
  methods: {
    supportClick() {
      openChatWidget();
    },
  },
  components: {},
};
</script>
<style scoped>
.footer {
  background-color: #f6fafd;
  padding-left: 18vw;
  padding-right: 18vw;
  padding-top: 5%;
  padding-bottom: 5%;
  color: #333333;
  display: grid;
  grid-template-columns: 2fr 1.3fr 1.3fr 1.3fr;
  gap: 20px;
  border-radius: 30px 30px 0 0;
  margin-top: 3%;
}
.logoFooter {
  gap: 20px;
  display: flex;
  flex-direction: column;
}
.logoFooter p {
  font-size: 14px;
  color: #8b8b8b;
}
.writeUs {
  border-radius: 46px;
  background-color: #ff8989;
  border: 1px solid #ff8989;
  color: #ffffff;
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 7px;
  padding: 2% 5% 2% 5%;
  cursor: pointer;
  width: fit-content;
}
.blockFooter {
  display: flex;
  flex-direction: column;
  gap: 7px;
}
.blockFooter p {
  color: #757575;
  font-size: 16px;
}
.footerHeaderText {
  font-size: 18px !important;
  font-weight: 600 !important;
  color: #333333 !important;
}

.mobileFooter {
  background-color: #f6fafd;
  padding-left: 7%;
  padding-right: 7%;
  padding-top: 15%;
  padding-bottom: 5%;
  color: #333333;
  display: none;
  grid-template-columns: 1fr 1fr;
  border-radius: 30px 30px 0 0;
  margin-top: 3%;
}
.mobileFooter p {
  font-size: 14px;
  color: #757575;
}
.mobileLogoFooter {
  display: flex;
  flex-direction: column;
  justify-content: space-between;
}
.mobileLogoFooter p {
  font-size: 14px;
  color: #757575;
}
.mobileWriteUs {
  border-radius: 46px;
  background-color: #ff8989;
  border: 1px solid #ff8989;
  color: #ffffff;
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 7px;
  padding: 2% 5% 2% 5%;
  cursor: pointer;
  width: fit-content;
}
.mobileBlockFooter {
  display: flex;
  flex-direction: column;
  gap: 7px;
}
.mobileBlockFooter a {
  color: #757575;
  font-size: 14px;
}
.mobileFooterHeaderText {
  font-size: 16px !important;
  font-weight: 600 !important;
  color: #333333 !important;
}
@media (max-width: 968px) {
  .footer {
    display: none;
  }
  .mobileFooter {
    display: grid;
  }
  .mobileLogoFooter img {
    width: 70%;
  }
  .mobileBlockFooter {
    margin-bottom: 7%;
    margin-top: 20%;
  }
  .mobileWriteUs {
    font-size: 14px;
    margin-top: 7%;
    padding: 7% 13% 7% 13%;
  }
}
</style>
